<template>
  <div>
    <b-modal id="modalFormAddCardPools" ref="modalFormAddCardPools" :title="$t('Cards pool')" hide-footer size="lg">
      <div v-if="selectedCardPools">
        <b-form-group label-align="right" :label="$t('Cards count')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="selectedCardPools.size" aria-describedby="inputFeedbackCardsCount" :state="selectedCardPools.size > 0"/>
          <b-form-invalid-feedback id="inputFeedbackCardsCount">
            {{ $t('Enter cards count') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Balance')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="selectedCardPools.balance" aria-describedby="inputFeedbackBalance" :state="selectedCardPools.balance > 0"/>
          <b-form-invalid-feedback id="inputFeedbackBalance">
            {{ $t('Enter balance') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Currency')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select :options="listOfCurrency" v-model="selectedCardPools.currency"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('PIN code length')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select :options="listOfPinCode" v-model="selectedCardPools.sec_size"/>
        </b-form-group>
        <b-row>
          <b-col>
            <b-form-group label-align="right" :label="$t('Random numbers')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-checkbox v-model="randomNumbers"/>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label-align="right" :label="$t('Unique PIN')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-checkbox v-model="uniquePin"/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label-align="right" :label="$t('Activate before')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="datetime-local" v-model="selectedCardPools.expire" :disabled="notInstalled"/>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label-align="right" :label="$t('Not installed')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-checkbox v-model="notInstalled"/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group label-align="right" :label="$t('Days to use')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="selectedCardPools.days"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Tariff ID')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-input-group>
            <b-form-input type="text" disabled v-model="selectedCardPools.service_id"/>
            <b-input-group-append>
              <b-button size="sm" @click="showModalTariff">{{ $t('Select') }}</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="save">{{ $t('Save') }}</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="hideModalFormAddCardPools">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <b-modal ref="modalTariff" id="modalTariff" hide-footer :title="$t('Tariff plans')" size="lg">
      <b-table sticky-header striped hover small
        :items="tariffItems"
        :fields="tariffFields"
        selectable
        select-mode="single"
        @row-clicked="rowClickTariff">
        <template v-slot:cell(balanceRollover)="data">
          <b-form-checkbox disabled v-model="data.value"/>
        </template>
      </b-table>
      <b-row>
        <b-col>
          <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="selectTariff">Ok</b-button>
        </b-col>
        <b-col sm="1.5">
          <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="$bvModal.hide('modalTariff')">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    selectedCardPools: null,
    editItem: null
  },
  data () {
    return {
      currentTariff: null,
      randomNumbers: false,
      uniquePin: false,
      notInstalled: false,
      listOfPinCode: [
        {value: 8, text: 8},
        {value: 12, text: 12},
        {value: 16, text: 16}
      ],
      tariffFields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'create_date', label: this.$i18n.t('Created on'), sortable: true},
        {key: 'whoCreate', label: this.$i18n.t('Created by'), sortable: true},
        {key: 'change_date', label: this.$i18n.t('Modified on'), sortable: true},
        {key: 'whoChange', label: this.$i18n.t('Modified by'), sortable: true},
        {key: 'balanceRollover', label: this.$i18n.t('Zero balance at the accounting period end'), sortable: true},
        {key: 'comments', label: this.$i18n.t('Comment'), sortable: true}
      ]
    }
  },
  methods: {
    save () {
      if (!this.selectedCardPools.size) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Cards count field is invalid'), 'Error')
        return
      }
      if (!this.selectedCardPools.balance) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Balance field is invalid'), 'Error')
        return
      }

      this.selectedCardPools.size = Number(this.selectedCardPools.size)
      this.selectedCardPools.balance = Number(this.selectedCardPools.balance)
      this.selectedCardPools.days = Number(this.selectedCardPools.days)
      if (this.notInstalled) {
        this.selectedCardPools.expire = Number(Date.parse(moment().format('2033-05-18T06:33'))) / 1000
      } else {
        this.selectedCardPools.expire = Number(Date.parse(this.selectedCardPools.expire)) / 1000
      }
      if (this.randomNumbers && this.uniquePin) {
        this.selectedCardPools.random = 3
      } else if (this.uniquePin && !this.randomNumbers) {
        this.selectedCardPools.random = 2
      } else if (!this.uniquePin && this.randomNumbers) {
        this.selectedCardPools.random = 1
      } else {
        this.selectedCardPools.random = 0
      }
      let response = this.$store.dispatch('Users/CREATE_CARD_POOLS', this.selectedCardPools)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          if (this.selectedCardPools.pool_id) {
            this.$store.dispatch('Users/GET_CARD_POOL', this.editItem.pool_id).then(response => {
              this.editItem.info = this.$store.getters['Users/CARD_POOL'].info
            })
          }
          setTimeout(this.$store.dispatch, 500, 'Users/GET_CARD_POOLS')
          this.$refs.modalFormAddCardPools.hide()
          this.$root.$emit('makeToasts')
        }
      })
    },
    hideModalFormAddCardPools () {
      this.$refs.modalFormAddCardPools.hide()
    },
    showModalTariff () {
      this.currentTariff = null
      this.$refs.modalTariff.show()
    },
    rowClickTariff (row) {
      this.currentTariff = row
    },
    selectTariff () {
      if (!this.currentTariff) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select tariff'), 'Error')
        return
      }
      this.selectedCardPools.service_id = this.currentTariff.id
      this.$refs.modalTariff.hide()
    }
  },
  computed: {
    listOfCurrency () {
      let tmp = []
      for (let el of this.$store.getters['ReferenceBooks/CURRENCIES']) {
        let newEl = {
          value: 0,
          text: ''
        }
        newEl.value = el.currency_id
        newEl.text = el.currency_brief_name
        tmp.push(newEl)
      }
      return tmp
    },
    tariffItems () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/TARIFFS']))
      for (let el of copy) {
        for (let elSystemUsers of this.$store.getters['Users/SYSTEM_USERS']) {
          if (elSystemUsers.user_id === el.who_create) {
            el.whoCreate = elSystemUsers.login + ' (' + elSystemUsers.user_id + ')'
          }
          if (elSystemUsers.user_id === el.who_change) {
            el.whoChange = elSystemUsers.login + ' (' + elSystemUsers.user_id + ')'
          }
        }
        if (el.change_date === 0) {
          el.change_date = this.$i18n.t('Not installed')
        } else {
          el.change_date = moment(Number(el.change_date) * 1000).format('DD-MM-YYYY hh:mm:ss')
        }
        if (el.create_date === 0) {
          el.create_date = this.$i18n.t('Not installed')
        } else {
          el.create_date = moment(Number(el.create_date) * 1000).format('DD-MM-YYYY hh:mm:ss')
        }
        if (el.balance_rollover === 1) {
          el.balanceRollover = true
        } else {
          el.balanceRollover = false
        }
      }
      return copy
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/cardPools/formAdd.vue